import classNames from 'classnames';
import React from 'react';
import { LegacyIconRenderer } from "../../../../helper/components/LegacyIconRenderer.js";
import { Typography } from "../../../typography/Typography.js";
import styles from "./Modal.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Modal({
  headerImage,
  children,
  headerImageAlt,
  isOpen,
  className,
  headerIcon,
  headerText
}) {
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.modalWrapper, className, {
      [styles.modalOpen]: isOpen
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.modal,
      role: "dialog",
      "aria-modal": "true",
      tabIndex: -1,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.modalHeader,
        children: [headerImage && /*#__PURE__*/_jsx("img", {
          src: headerImage,
          alt: headerImageAlt
        }), !headerImage && headerIcon && /*#__PURE__*/_jsxs("div", {
          className: styles.modalIconWrapper,
          children: [/*#__PURE__*/_jsx(LegacyIconRenderer, {
            className: styles.icon,
            icon: headerIcon,
            size: 40
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "span",
            margin: false,
            children: headerText ?? ''
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.modalBody,
        children: children
      })]
    })
  });
}